import { render, staticRenderFns } from "./SingerCarousel.vue?vue&type=template&id=b5fd123e&scoped=true"
import script from "./SingerCarousel.vue?vue&type=script&lang=js"
export * from "./SingerCarousel.vue?vue&type=script&lang=js"
import style0 from "./SingerCarousel.vue?vue&type=style&index=0&id=b5fd123e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fd123e",
  null
  
)

export default component.exports